import React from "react";
import { Box, Typography } from "@mui/material";
import { formatExecutionStepError, hasExecutionStepError } from "./caseExecutionJobDetailsUtils";

type ExecutionStepErrorBoxProps = {
  error: unknown;
};

const ExecutionStepErrorBox = ({ error }: ExecutionStepErrorBoxProps) => {
  if (!hasExecutionStepError(error)) {
    return null;
  }

  return (
    <Box
      sx={{
        mx: "1rem",
        mt: "1rem",
        p: "1rem",
        borderRadius: "8px",
        backgroundColor: "rgba(244, 67, 54, 0.12)",
      }}
    >
      <Typography
        component={"pre"}
        sx={{
          m: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontFamily: "monospace",
          fontSize: "0.875rem",
        }}
      >
        {formatExecutionStepError(error)}
      </Typography>
    </Box>
  );
};

export default ExecutionStepErrorBox;
